import React, { FC } from 'react';
import { useStoreon } from 'storeon/react';
import { GxTab } from '@garpix/garpix-web-components-react';
import { Events, State } from '@/interfaces';
import { MODAL_USER_PANELS, TYPE_USER } from '../../../../../const';
import styles from '../styles/index.module.scss';

interface IModalUserTabNavs {
  onClickDeposit: (id: any) => void;
  isEdit: boolean;
}

const ModalUserTabNavs: FC<IModalUserTabNavs> = ({ onClickDeposit, isEdit }) => {
  const { currentUser } = useStoreon<State, Events>('currentUser');
  return (
    <>
      <GxTab
        className={styles['tabs-group--item']}
        slot="nav"
        panel={MODAL_USER_PANELS.data}
      >
        Данные
      </GxTab>
      <GxTab
        className={styles['tabs-group--item']}
        slot="nav"
        panel={MODAL_USER_PANELS.statistics}
        disabled={!isEdit}
      >
        Заявки
      </GxTab>
      {currentUser.user_status !== TYPE_USER.VIEWER && (
        <>
          {/* <GxTab
            className={styles['tabs-group--item']}
            slot="nav"
            panel={MODAL_USER_PANELS.documents}
          >
            Документы
          </GxTab> */}
          <GxTab
            className={styles['tabs-group--item']}
            slot="nav"
            panel={MODAL_USER_PANELS.payOrder}
            disabled={!isEdit}
          >
            Счета
          </GxTab>
          <GxTab
            className={styles['tabs-group--item']}
            slot="nav"
            panel={MODAL_USER_PANELS.deposits}
            onClick={onClickDeposit}
            disabled={!isEdit}
          >
            Депозиты
          </GxTab>
          <GxTab
            className={styles['tabs-group--item']}
            slot="nav"
            panel={MODAL_USER_PANELS.certificates}
            disabled={!isEdit}
          >
            Сертификаты
          </GxTab>
        </>
      )}
    </>
  );
};

export default ModalUserTabNavs;
